// src/config/formsConfig.js
import { z } from "zod";

export const servicesCatalog = [
  { name: "Aire Acondicionado", slug: "aire_acondicionado" },
  { name: "Albañilería", slug: "albanileria" },
  { name: "Arquitectura", slug: "arquitectura" },
  { name: "Belleza Personal", slug: "belleza_personal" },
  { name: "Carpintería", slug: "carpinteria" },
  { name: "Cerrajería", slug: "cerrajeria" },
  { name: "Control de Plagas", slug: "control_plagas" },
  { name: "Cuidado de Mayores", slug: "cuidado_mayores" },
  { name: "Cuidado de Niños", slug: "cuidado_ninos" },
  { name: "Decoradores", slug: "decoradores" },
  { name: "Electricista", slug: "electricista" },
  { name: "Entrenamiento", slug: "entrenamiento" },
  { name: "Gasista", slug: "gasista" },
  { name: "Herrero", slug: "herrero" },
  { name: "Infantiles (Fiestas)", slug: "infantiles" },
  { name: "Instalador General", slug: "instalador_general" },
  { name: "Jardinero", slug: "jardinero" },
  { name: "Mascotas", slug: "mascotas" },
  { name: "Mecánica Automotriz", slug: "mecanica_automotriz" },
  { name: "Mudanzas", slug: "mudanzas" },
  { name: "Piletas", slug: "piletas" },
  { name: "Pintores", slug: "pintores" },
  { name: "Plomeros", slug: "plomeros" },
  { name: "Seguridad", slug: "seguridad" },
  { name: "Servicio Doméstico", slug: "servicio_domestico" },
  { name: "Tapicero", slug: "tapicero" },
  { name: "Tecnología", slug: "tecnologia" }
];
export const serviceSlugs = servicesCatalog.map(s => s.slug);

export const commonFields = [
  { key: 'titulo', type: 'text', label: 'Título', required: true, min: 10, max: 80 },
  { key: 'descripcion', type: 'textarea', label: 'Descripción', required: true, min: 30, max: 1500 },
  { key: 'ubicacion.direccion', type: 'text', label: 'Dirección', required: true },
  { key: 'ubicacion.ciudad', type: 'text', label: 'Ciudad', required: true },
  { key: 'ubicacion.provincia', type: 'text', label: 'Provincia', required: true },
  { key: 'acceso', type: 'select', label: 'Acceso', options: ['Departamento','Casa','Local/Oficina','Obra','Otro'] },
  { key: 'urgencia', type: 'radio', label: 'Urgencia', required: true, options: ['Cuando se pueda','En la semana','Urgente (48h)'] },
  { key: 'horarios_preferidos', type: 'timeslots', label: 'Horarios preferidos' },
  { key: 'fotos', type: 'files', label: 'Fotos (0–6)', maxFiles: 6 },
  { key: 'presupuesto_estimado', type: 'number', label: 'Presupuesto estimado (ARS)' },
  { key: 'acepta_visita', type: 'checkbox', label: 'Acepto visita para presupuesto', defaultValue: true },
  { key: 'acepta_presupuesto_previo', type: 'checkbox', label: 'Acepto recibir presupuesto previo', defaultValue: true },
  { key: 'terminos_aceptados', type: 'checkbox', label: 'Acepto Términos y Condiciones', required: true }
];

export const serviceForms = {
  aire_acondicionado: [
    { key: 'tipo_trabajo', type: 'select', label: 'Tipo de trabajo', required: true, options: ['Instalación','Reparación','Mantenimiento','Desinstalación'] },
    { key: 'tipo_equipo', type: 'select', label: 'Tipo de equipo', required: true, options: ['Split','Window','Central','Portátil'] },
    { key: 'potencia_frio_kw', type: 'number', label: 'Potencia frío (kW)' },
    { key: 'marca_modelo', type: 'text', label: 'Marca/Modelo' },
    { key: 'tiene_soporte', type: 'checkbox', label: 'Tengo soporte/soportes' },
    { key: 'carga_gas_requerida', type: 'checkbox', label: 'Requiere carga de gas' }
  ],
  gasista: [
    { key: 'tipo_trabajo', type: 'select', label: 'Tipo de trabajo', required: true, options: ['Instalación nueva','Reparación','Mantenimiento','Inspección'] },
    { key: 'artefacto', type: 'multiselect', label: 'Artefacto', options: ['Cocina','Calefón','Termotanque','Estufa','Horno','Otro'] },
    { key: 'requiere_matricula', type: 'checkbox', label: 'Requiere profesional matriculado', defaultValue: true },
    { key: 'estado_instalacion', type: 'select', label: 'Estado de la instalación', options: ['Nueva','Antigua','Desconocida'] },
    { key: 'posible_corte_suministro', type: 'checkbox', label: 'Se puede cortar el gas' }
  ],
  mudanzas: [
    { key: 'tipo_mudanza', type: 'select', label: 'Tipo de mudanza', required: true, options: ['Hogar','Oficina','Local','Otra'] },
    { key: 'volumen_aprox_m3', type: 'number', label: 'Volumen aprox. (m³)' },
    { key: 'cantidad_ambientes', type: 'number', label: 'Cantidad de ambientes' },
    { key: 'requiere_empaque', type: 'checkbox', label: 'Requiere empaque' },
    { key: 'requiere_montacargas', type: 'checkbox', label: 'Requiere montacargas' },
    { key: 'incluye_armado_desarmado', type: 'checkbox', label: 'Incluye armado/desarmado' },
    { key: 'distancia_km', type: 'number', label: 'Distancia estimada (km)' }
  ],
  mecanica_automotriz: [
    { key: 'tipo_servicio', type: 'multiselect', label: 'Tipo de servicio', required: true, options: ['Mantenimiento preventivo','Cambio de aceite','Frenos','Suspensión','Motor','Electricidad','Diagnóstico','Otro'] },
    { key: 'marca_modelo_auto', type: 'text', label: 'Marca/Modelo', required: true },
    { key: 'anio_auto', type: 'number', label: 'Año', required: true },
    { key: 'combustible', type: 'select', label: 'Combustible', options: ['Nafta','Diesel','GNC','Híbrido','Eléctrico'] },
    { key: 'problema_descripto', type: 'textarea', label: 'Descripción del problema' }
  ],
  piletas: [
    { key: 'tipo_servicio', type: 'multiselect', label: 'Tipo de servicio', required: true, options: ['Mantenimiento regular','Limpieza puntual','Instalación de bomba/filtro','Revestimiento','Reparación pérdidas','Cloración salina'] },
    { key: 'dimensiones_aprox_m', type: 'text', label: 'Dimensiones aprox. (m)' },
    { key: 'material_pileta', type: 'select', label: 'Material', options: ['Hormigón','Fibra','Lona','Otro'] },
    { key: 'estado_actual', type: 'select', label: 'Estado actual', options: ['Buena','Suciedad','Algas','Agua verde','Otro'] },
    { key: 'requiere_insumos', type: 'checkbox', label: 'Requiere insumos del prestador' }
  ],
  cerrajeria: [
    { key: 'tipo_trabajo', type: 'select', label: 'Tipo de trabajo', required: true, options: ['Apertura urgente','Cambio de cerradura','Colocación cerradura','Copia llaves','Reparación cerradura','Seguridad adicional'] },
    { key: 'tipo_cerradura', type: 'select', label: 'Tipo de cerradura', options: ['Convencional','Seguridad multipunto','Electrónica','Otra'] },
    { key: 'ubicacion_cerradura', type: 'select', label: 'Ubicación', options: ['Puerta principal','Puerta interna','Caja fuerte','Vehículo','Otro'] },
    { key: 'urgencia_servicio', type: 'select', label: 'Urgencia', required: true, options: ['Normal','Urgente (2h)','Emergencia inmediata'] }
  ],
  cuidado_ninos: [
    { key: 'edad_ninos', type: 'number', label: 'Edad de los niños', required: true },
    { key: 'cantidad_ninos', type: 'number', label: 'Cantidad de niños', required: true },
    { key: 'tipo_servicio', type: 'select', label: 'Tipo de servicio', required: true, options: ['Niñera eventual','Niñera fija','Acompañamiento escolar','Transporte'] },
    { key: 'horarios_requeridos', type: 'text', label: 'Horarios requeridos', required: true },
    { key: 'requiere_referencias', type: 'checkbox', label: 'Requiere referencias' },
    { key: 'tareas_extra', type: 'multiselect', label: 'Tareas extra', options: ['Cocinar','Limpieza ligera','Apoyo escolar','Otro'] }
  ],
  cuidado_mayores: [
    { key: 'tipo_servicio', type: 'select', label: 'Tipo de servicio', required: true, options: ['Acompañamiento','Enfermería','Asistencia diaria','Traslado'] },
    { key: 'estado_salud', type: 'select', label: 'Estado de salud', options: ['Independiente','Con movilidad reducida','Postrado','Enfermedad crónica'] },
    { key: 'horarios_requeridos', type: 'text', label: 'Horarios requeridos', required: true },
    { key: 'requiere_medicacion', type: 'checkbox', label: 'Requiere administración de medicación' },
    { key: 'tareas_extra', type: 'multiselect', label: 'Tareas extra', options: ['Cocinar','Higiene personal','Compras','Otro'] }
  ],
  belleza_personal: [
    { key: 'tipo_servicio', type: 'multiselect', label: 'Tipo de servicio', required: true, options: ['Peluquería','Manicuría/Pedicuría','Maquillaje','Depilación','Masajes','Tratamientos faciales','Otro'] },
    { key: 'servicio_domicilio', type: 'checkbox', label: 'Servicio a domicilio' },
    { key: 'fecha_evento', type: 'date', label: 'Fecha de evento' },
    { key: 'requiere_productos_prestador', type: 'checkbox', label: 'Requiere productos del prestador' }
  ],
  mascotas: [
    { key: 'tipo_servicio', type: 'select', label: 'Tipo de servicio', required: true, options: ['Paseo','Cuidado en domicilio','Cuidado en guardería','Veterinaria','Adiestramiento','Peluquería canina/felina'] },
    { key: 'tipo_mascota', type: 'select', label: 'Tipo de mascota', required: true, options: ['Perro','Gato','Ave','Otro'] },
    { key: 'raza', type: 'text', label: 'Raza' },
    { key: 'edad', type: 'number', label: 'Edad (años)' },
    { key: 'cantidad', type: 'number', label: 'Cantidad', required: true },
    { key: 'requerimientos_especiales', type: 'textarea', label: 'Requerimientos especiales' }
  ],
  tapicero: [
    { key: 'tipo_trabajo', type: 'select', label: 'Tipo de trabajo', required: true, options: ['Tapizado nuevo','Restauración','Reparación parcial','Cambio de tela'] },
    { key: 'tipo_mueble', type: 'multiselect', label: 'Tipo de mueble', required: true, options: ['Sillas','Sillones','Butacas','Camas','Otro'] },
    { key: 'medidas_aprox', type: 'text', label: 'Medidas aproximadas' },
    { key: 'tipo_tela', type: 'select', label: 'Tipo de tela', options: ['Cuero','Tela','Sintético','Otro'] },
    { key: 'estado_actual', type: 'select', label: 'Estado actual', options: ['Roto','Desgastado','Sucio','Otro'] }
  ],
  arquitectura: [
    { key: 'tipo_proyecto', type: 'select', label: 'Tipo de proyecto', required: true, options: ['Vivienda unifamiliar','Edificio','Comercial','Industrial','Remodelación','Otro'] },
    { key: 'superficie_aprox_m2', type: 'number', label: 'Superficie aprox. (m²)' },
    { key: 'tiene_planos_previos', type: 'checkbox', label: 'Tengo planos previos' },
    { key: 'requiere_direccion_obra', type: 'checkbox', label: 'Requiere dirección de obra' },
    { key: 'fecha_inicio_estimada', type: 'date', label: 'Fecha de inicio estimada' }
  ],
  decoradores: [
    { key: 'tipo_espacio', type: 'select', label: 'Tipo de espacio', required: true, options: ['Hogar','Oficina','Local comercial','Evento'] },
    { key: 'estilo_preferido', type: 'text', label: 'Estilo preferido' },
    { key: 'requiere_renderizado', type: 'checkbox', label: 'Requiere renders' },
    { key: 'requiere_muebles_a_medida', type: 'checkbox', label: 'Requiere muebles a medida' }
  ],
  entrenamiento: [
    { key: 'tipo_entrenamiento', type: 'multiselect', label: 'Tipo de entrenamiento', required: true, options: ['Personal trainer','Crossfit','Yoga','Pilates','Funcional','Artes marciales','Otro'] },
    { key: 'nivel_cliente', type: 'select', label: 'Nivel', options: ['Principiante','Intermedio','Avanzado'] },
    { key: 'frecuencia', type: 'select', label: 'Frecuencia', required: true, options: ['1 vez/semana','2–3 veces/semana','Diario'] },
    { key: 'objetivos', type: 'textarea', label: 'Objetivos' },
    { key: 'requiere_equipamiento', type: 'checkbox', label: 'Requiere equipamiento del prestador' }
  ],
  control_plagas: [
    { key: 'tipo_plaga', type: 'multiselect', label: 'Tipo de plaga', required: true, options: ['Cucarachas','Hormigas','Ratas','Arañas','Mosquitos','Otros'] },
    { key: 'tipo_espacio', type: 'select', label: 'Tipo de espacio', required: true, options: ['Casa','Departamento','Oficina','Galpón','Otro'] },
    { key: 'superficie_aprox_m2', type: 'number', label: 'Superficie aprox. (m²)' },
    { key: 'tratamientos_previos', type: 'checkbox', label: 'Se realizaron tratamientos previos' },
    { key: 'requiere_certificado', type: 'checkbox', label: 'Requiere certificado' }
  ],
  seguridad: [
    { key: 'tipo_servicio', type: 'multiselect', label: 'Tipo de servicio', required: true, options: ['Alarmas','Cámaras CCTV','Monitoreo','Vigilancia presencial','Control de accesos','Otro'] },
    { key: 'tipo_propiedad', type: 'select', label: 'Tipo de propiedad', required: true, options: ['Casa','Departamento','Edificio','Comercio','Industria'] },
    { key: 'cantidad_accesos', type: 'number', label: 'Cantidad de accesos' },
    { key: 'requiere_mantenimiento', type: 'checkbox', label: 'Requiere plan de mantenimiento' }
  ],
  tecnologia: [
    { key: 'tipo_servicio', type: 'multiselect', label: 'Tipo de servicio', required: true, options: ['Reparación PC','Reparación Celular','Instalación de redes','Smart Home','CCTV','Soporte técnico','Otro'] },
    { key: 'marca_modelo', type: 'text', label: 'Marca/Modelo' },
    { key: 'sistema_operativo', type: 'text', label: 'Sistema operativo' },
    { key: 'urgencia_servicio', type: 'select', label: 'Urgencia', options: ['Normal','Urgente (24h)','Emergencia'] },
    { key: 'requiere_visita_domicilio', type: 'checkbox', label: 'Requiere visita a domicilio' }
  ],
  infantiles: [
    { key: 'tipo_evento', type: 'select', label: 'Tipo de evento', required: true, options: ['Cumpleaños','Bautismo','Comunión','Otro'] },
    { key: 'cantidad_invitados', type: 'number', label: 'Cantidad de invitados', required: true },
    { key: 'lugar_evento', type: 'text', label: 'Lugar del evento', required: true },
    { key: 'servicios_requeridos', type: 'multiselect', label: 'Servicios requeridos', required: true, options: ['Animación','Catering','Decoración','Inflables','Show','Fotografía','Otro'] },
    { key: 'fecha_evento', type: 'date', label: 'Fecha del evento', required: true }
  ],
  herrero: [
    { key: 'tipo_trabajo', type: 'multiselect', label: 'Tipo de trabajo', required: true, options: ['Rejas','Portones','Estructuras metálicas','Soldadura','Mantenimiento','Otro'] },
    { key: 'material', type: 'select', label: 'Material', options: ['Hierro','Acero inoxidable','Aluminio','Otro'] },
    { key: 'medidas_aprox', type: 'text', label: 'Medidas aproximadas' },
    { key: 'requiere_pintura_protectora', type: 'checkbox', label: 'Requiere pintura protectora' }
  ],
  instalador_general: [
    { key: 'tipo_instalacion', type: 'multiselect', label: 'Tipo de instalación', required: true, options: ['Electrodomésticos','Muebles','TV/Audio','Redes','Smart Home','Otro'] },
    { key: 'requiere_materiales', type: 'checkbox', label: 'Requiere materiales del prestador' },
    { key: 'marca_modelo_equipo', type: 'text', label: 'Marca/Modelo del equipo' },
    { key: 'manual_instrucciones_disponible', type: 'checkbox', label: 'Tengo manual de instrucciones' }
  ],
  albanileria: [
    { key: 'tipo_trabajo', type: 'multiselect', label: 'Tipo de trabajo', required: true, options: ['Demolición','Albañilería','Revoque','Colocación de cerámicos/porcelanato','Yeso','Impermeabilización','Estructuras metálicas','Hormigón','Otro'] },
    { key: 'superficie_aprox_m2', type: 'number', label: 'Superficie aprox (m²)' },
    { key: 'planos_disponibles', type: 'checkbox', label: 'Tengo planos' },
    { key: 'permiso_municipal', type: 'checkbox', label: 'Requiere permiso municipal' },
    { key: 'materiales_incluidos', type: 'select', label: 'Materiales', required: true, options: ['Solo mano de obra','Materiales incluidos','A definir'] },
    { key: 'fecha_objetivo', type: 'date', label: 'Fecha objetivo' },
    { key: 'adjuntos', type: 'files', label: 'Adjuntos (planos/fotos)', maxFiles: 5 }
  ],
  pintores: [
    { key: 'superficie_a_pintar_m2', type: 'number', label: 'Superficie a pintar (m²)', required: true },
    { key: 'tipo_superficie', type: 'multiselect', label: 'Tipo de superficie', required: true, options: ['Pared interior','Pared exterior','Cielorraso','Puertas/Marcos','Rejas','Pisos','Otro'] },
    { key: 'estado_actual', type: 'select', label: 'Estado actual', required: true, options: ['Bueno','Con fisuras','Húmedo','Descascarado'] },
    { key: 'incluye_enduido_y_lijado', type: 'checkbox', label: 'Incluir enduido y lijado' },
    { key: 'provee_pintura', type: 'select', label: '¿Quién provee la pintura?', required: true, options: ['Cliente','Prestador','A definir'] },
    { key: 'colores_referencia', type: 'text', label: 'Colores / referencias' }
  ],
  plomeros: [
    { key: 'tipo_problema', type: 'multiselect', label: 'Tipo de problema', required: true, options: ['Pérdida/Fuga','Baja presión','Instalación nueva','Reemplazo cañerías','Cloacas','Calefón/Termotanque','Artefactos (bacha, inodoro, grifería)'] },
    { key: 'tiene_llave_paso_accesible', type: 'checkbox', label: 'Tengo llave de paso accesible' },
    { key: 'antiguedad_instalacion', type: 'select', label: 'Antigüedad de la instalación', options: ['0–5 años','5–10','10–20','20+'] },
    { key: 'hay_filtraciones_visibles', type: 'checkbox', label: 'Hay filtraciones visibles' },
    { key: 'corte_servicio_posible', type: 'checkbox', label: 'Se puede cortar el servicio' }
  ],
  electricista: [
    { key: 'tipo_trabajo', type: 'multiselect', label: 'Tipo de trabajo', required: true, options: ['Corto/Salta térmica','Nueva instalación','Tablero','Tomas/Interruptores','Luces/LED','Puesta a tierra','Cableado estructurado','Otro'] },
    { key: 'potencia_total_estimada_kw', type: 'number', label: 'Potencia total estimada (kW)' },
    { key: 'disyuntor_y_termicas_estado', type: 'select', label: 'Estado disyuntor/térmicas', options: ['Desconocido','Antiguo','Correcto','A reemplazar'] },
    { key: 'altura_trabajo_m', type: 'number', label: 'Altura de trabajo (m)' },
    { key: 'corte_energia_posible', type: 'checkbox', label: 'Se puede cortar la energía' }
  ],
  carpinteria: [
    { key: 'material', type: 'select', label: 'Material', required: true, options: ['MDF','Madera maciza','Melamina','Aluminio','PVC','Otro'] },
    { key: 'tipo_elemento', type: 'multiselect', label: 'Tipo de elemento', required: true, options: ['Muebles a medida','Puertas/Marcos','Placares','Aberturas','Reparaciones','Deck'] },
    { key: 'medidas_aprox', type: 'text', label: 'Medidas aproximadas' },
    { key: 'terminacion', type: 'select', label: 'Terminación', options: ['Laca','Barniz','Pintura','Enchapado','Melamina','Sin terminación'] }
  ],
  jardinero: [
    { key: 'tipo_servicio', type: 'multiselect', label: 'Tipo de servicio', required: true, options: ['Corte de césped','Poda','Diseño de jardín','Riego','Limpieza','Control de plagas'] },
    { key: 'area_m2', type: 'number', label: 'Área (m²)' },
    { key: 'retiro_de_residuos', type: 'checkbox', label: 'Retiro de residuos' },
    { key: 'frecuencia', type: 'select', label: 'Frecuencia', options: ['Único','Semanal','Quincenal','Mensual'] }
  ],
  servicio_domestico: [
    { key: 'tipo_espacio', type: 'select', label: 'Tipo de espacio', required: true, options: ['Hogar','Oficina','Obra post-construcción','Mudanza','Profunda'] },
    { key: 'superficie_m2', type: 'number', label: 'Superficie (m²)' },
    { key: 'cantidad_ambientes', type: 'number', label: 'Ambientes' },
    { key: 'provee_insumos', type: 'select', label: '¿Quién provee insumos?', required: true, options: ['Cliente','Prestador','A definir'] },
    { key: 'frecuencia', type: 'select', label: 'Frecuencia', options: ['Único','Semanal','Quincenal','Mensual'] }
  ]
};

export const commonSchema = z.object({
  titulo: z.string().min(10).max(80),
  descripcion: z.string().min(30).max(1500),
  ubicacion: z.object({
    direccion: z.string().min(3),
    ciudad: z.string().min(2),
    provincia: z.string().min(2),
    coords: z.object({ lat: z.number(), lng: z.number() }).optional()
  }),
  acceso: z.enum(['Departamento','Casa','Local/Oficina','Obra','Otro']).optional(),
  urgencia: z.enum(['Cuando se pueda','En la semana','Urgente (48h)']),
  horarios_preferidos: z.any().optional(),
  fotos: z.any().optional(),
  presupuesto_estimado: z.coerce.number().positive().optional(),
  acepta_visita: z.boolean().default(true).optional(),
  acepta_presupuesto_previo: z.boolean().default(true).optional(),
  terminos_aceptados: z.literal(true)
});

const numPos = z.coerce.number().positive({ message: 'Debe ser positivo' });

export const serviceSchemas = {
  aire_acondicionado: z.object({
    tipo_trabajo: z.enum(['Instalación','Reparación','Mantenimiento','Desinstalación']),
    tipo_equipo: z.enum(['Split','Window','Central','Portátil']),
    potencia_frio_kw: numPos.optional(),
    marca_modelo: z.string().optional(),
    tiene_soporte: z.boolean().optional(),
    carga_gas_requerida: z.boolean().optional()
  }),
  gasista: z.object({
    tipo_trabajo: z.enum(['Instalación nueva','Reparación','Mantenimiento','Inspección']),
    artefacto: z.array(z.enum(['Cocina','Calefón','Termotanque','Estufa','Horno','Otro'])).optional(),
    requiere_matricula: z.boolean().optional(),
    estado_instalacion: z.enum(['Nueva','Antigua','Desconocida']).optional(),
    posible_corte_suministro: z.boolean().optional()
  }),
  mudanzas: z.object({
    tipo_mudanza: z.enum(['Hogar','Oficina','Local','Otra']),
    volumen_aprox_m3: numPos.optional(),
    cantidad_ambientes: numPos.optional(),
    requiere_empaque: z.boolean().optional(),
    requiere_montacargas: z.boolean().optional(),
    incluye_armado_desarmado: z.boolean().optional(),
    distancia_km: numPos.optional()
  }),
  mecanica_automotriz: z.object({
    tipo_servicio: z.array(z.enum(['Mantenimiento preventivo','Cambio de aceite','Frenos','Suspensión','Motor','Electricidad','Diagnóstico','Otro'])).min(1),
    marca_modelo_auto: z.string().min(2),
    anio_auto: numPos,
    combustible: z.enum(['Nafta','Diesel','GNC','Híbrido','Eléctrico']).optional(),
    problema_descripto: z.string().optional()
  }),
  piletas: z.object({
    tipo_servicio: z.array(z.enum(['Mantenimiento regular','Limpieza puntual','Instalación de bomba/filtro','Revestimiento','Reparación pérdidas','Cloración salina'])).min(1),
    dimensiones_aprox_m: z.string().optional(),
    material_pileta: z.enum(['Hormigón','Fibra','Lona','Otro']).optional(),
    estado_actual: z.enum(['Buena','Suciedad','Algas','Agua verde','Otro']).optional(),
    requiere_insumos: z.boolean().optional()
  }),
  cerrajeria: z.object({
    tipo_trabajo: z.enum(['Apertura urgente','Cambio de cerradura','Colocación cerradura','Copia llaves','Reparación cerradura','Seguridad adicional']),
    tipo_cerradura: z.enum(['Convencional','Seguridad multipunto','Electrónica','Otra']).optional(),
    ubicacion_cerradura: z.enum(['Puerta principal','Puerta interna','Caja fuerte','Vehículo','Otro']).optional(),
    urgencia_servicio: z.enum(['Normal','Urgente (2h)','Emergencia inmediata'])
  }),
  cuidado_ninos: z.object({
    edad_ninos: numPos,
    cantidad_ninos: numPos,
    tipo_servicio: z.enum(['Niñera eventual','Niñera fija','Acompañamiento escolar','Transporte']),
    horarios_requeridos: z.string().min(2),
    requiere_referencias: z.boolean().optional(),
    tareas_extra: z.array(z.enum(['Cocinar','Limpieza ligera','Apoyo escolar','Otro'])).optional()
  }),
  cuidado_mayores: z.object({
    tipo_servicio: z.enum(['Acompañamiento','Enfermería','Asistencia diaria','Traslado']),
    estado_salud: z.enum(['Independiente','Con movilidad reducida','Postrado','Enfermedad crónica']).optional(),
    horarios_requeridos: z.string().min(2),
    requiere_medicacion: z.boolean().optional(),
    tareas_extra: z.array(z.enum(['Cocinar','Higiene personal','Compras','Otro'])).optional()
  }),
  belleza_personal: z.object({
    tipo_servicio: z.array(z.enum(['Peluquería','Manicuría/Pedicuría','Maquillaje','Depilación','Masajes','Tratamientos faciales','Otro'])).min(1),
    servicio_domicilio: z.boolean().optional(),
    fecha_evento: z.coerce.date().optional(),
    requiere_productos_prestador: z.boolean().optional()
  }),
  mascotas: z.object({
    tipo_servicio: z.enum(['Paseo','Cuidado en domicilio','Cuidado en guardería','Veterinaria','Adiestramiento','Peluquería canina/felina']),
    tipo_mascota: z.enum(['Perro','Gato','Ave','Otro']),
    raza: z.string().optional(),
    edad: numPos.optional(),
    cantidad: numPos,
    requerimientos_especiales: z.string().optional()
  }),
  tapicero: z.object({
    tipo_trabajo: z.enum(['Tapizado nuevo','Restauración','Reparación parcial','Cambio de tela']),
    tipo_mueble: z.array(z.enum(['Sillas','Sillones','Butacas','Camas','Otro'])).min(1),
    medidas_aprox: z.string().optional(),
    tipo_tela: z.enum(['Cuero','Tela','Sintético','Otro']).optional(),
    estado_actual: z.enum(['Roto','Desgastado','Sucio','Otro']).optional()
  }),
  arquitectura: z.object({
    tipo_proyecto: z.enum(['Vivienda unifamiliar','Edificio','Comercial','Industrial','Remodelación','Otro']),
    superficie_aprox_m2: numPos.optional(),
    tiene_planos_previos: z.boolean().optional(),
    requiere_direccion_obra: z.boolean().optional(),
    fecha_inicio_estimada: z.coerce.date().optional()
  }),
  decoradores: z.object({
    tipo_espacio: z.enum(['Hogar','Oficina','Local comercial','Evento']),
    estilo_preferido: z.string().optional(),
    requiere_renderizado: z.boolean().optional(),
    requiere_muebles_a_medida: z.boolean().optional()
  }),
  entrenamiento: z.object({
    tipo_entrenamiento: z.array(z.enum(['Personal trainer','Crossfit','Yoga','Pilates','Funcional','Artes marciales','Otro'])).min(1),
    nivel_cliente: z.enum(['Principiante','Intermedio','Avanzado']).optional(),
    frecuencia: z.enum(['1 vez/semana','2–3 veces/semana','Diario']),
    objetivos: z.string().optional(),
    requiere_equipamiento: z.boolean().optional()
  }),
  control_plagas: z.object({
    tipo_plaga: z.array(z.enum(['Cucarachas','Hormigas','Ratas','Arañas','Mosquitos','Otros'])).min(1),
    tipo_espacio: z.enum(['Casa','Departamento','Oficina','Galpón','Otro']),
    superficie_aprox_m2: numPos.optional(),
    tratamientos_previos: z.boolean().optional(),
    requiere_certificado: z.boolean().optional()
  }),
  seguridad: z.object({
    tipo_servicio: z.array(z.enum(['Alarmas','Cámaras CCTV','Monitoreo','Vigilancia presencial','Control de accesos','Otro'])).min(1),
    tipo_propiedad: z.enum(['Casa','Departamento','Edificio','Comercio','Industria']),
    cantidad_accesos: numPos.optional(),
    requiere_mantenimiento: z.boolean().optional()
  }),
  tecnologia: z.object({
    tipo_servicio: z.array(z.enum(['Reparación PC','Reparación Celular','Instalación de redes','Smart Home','CCTV','Soporte técnico','Otro'])).min(1),
    marca_modelo: z.string().optional(),
    sistema_operativo: z.string().optional(),
    urgencia_servicio: z.enum(['Normal','Urgente (24h)','Emergencia']).optional(),
    requiere_visita_domicilio: z.boolean().optional()
  }),
  infantiles: z.object({
    tipo_evento: z.enum(['Cumpleaños','Bautismo','Comunión','Otro']),
    cantidad_invitados: numPos,
    lugar_evento: z.string().min(2),
    servicios_requeridos: z.array(z.enum(['Animación','Catering','Decoración','Inflables','Show','Fotografía','Otro'])).min(1),
    fecha_evento: z.coerce.date()
  }),
  herrero: z.object({
    tipo_trabajo: z.array(z.enum(['Rejas','Portones','Estructuras metálicas','Soldadura','Mantenimiento','Otro'])).min(1),
    material: z.enum(['Hierro','Acero inoxidable','Aluminio','Otro']).optional(),
    medidas_aprox: z.string().optional(),
    requiere_pintura_protectora: z.boolean().optional()
  }),
  instalador_general: z.object({
    tipo_instalacion: z.array(z.enum(['Electrodomésticos','Muebles','TV/Audio','Redes','Smart Home','Otro'])).min(1),
    requiere_materiales: z.boolean().optional(),
    marca_modelo_equipo: z.string().optional(),
    manual_instrucciones_disponible: z.boolean().optional()
  }),
  albanileria: z.object({
    tipo_trabajo: z.array(z.enum(['Demolición','Albañilería','Revoque','Colocación de cerámicos/porcelanato','Yeso','Impermeabilización','Estructuras metálicas','Hormigón','Otro'])).min(1),
    superficie_aprox_m2: numPos.optional(),
    planos_disponibles: z.boolean().optional(),
    permiso_municipal: z.boolean().optional(),
    materiales_incluidos: z.enum(['Solo mano de obra','Materiales incluidos','A definir']),
    fecha_objetivo: z.coerce.date().optional(),
    adjuntos: z.any().optional()
  }),
  pintores: z.object({
    superficie_a_pintar_m2: numPos,
    tipo_superficie: z.array(z.enum(['Pared interior','Pared exterior','Cielorraso','Puertas/Marcos','Rejas','Pisos','Otro'])).min(1),
    estado_actual: z.enum(['Bueno','Con fisuras','Húmedo','Descascarado']),
    incluye_enduido_y_lijado: z.boolean().optional(),
    provee_pintura: z.enum(['Cliente','Prestador','A definir']),
    colores_referencia: z.string().optional()
  }),
  plomeros: z.object({
    tipo_problema: z.array(z.enum(['Pérdida/Fuga','Baja presión','Instalación nueva','Reemplazo cañerías','Cloacas','Calefón/Termotanque','Artefactos (bacha, inodoro, grifería)'])).min(1),
    tiene_llave_paso_accesible: z.boolean().optional(),
    antiguedad_instalacion: z.enum(['0–5 años','5–10','10–20','20+']).optional(),
    hay_filtraciones_visibles: z.boolean().optional(),
    corte_servicio_posible: z.boolean().optional()
  }),
  electricista: z.object({
    tipo_trabajo: z.array(z.enum(['Corto/Salta térmica','Nueva instalación','Tablero','Tomas/Interruptores','Luces/LED','Puesta a tierra','Cableado estructurado','Otro'])).min(1),
    potencia_total_estimada_kw: numPos.optional(),
    disyuntor_y_termicas_estado: z.enum(['Desconocido','Antiguo','Correcto','A reemplazar']).optional(),
    altura_trabajo_m: numPos.optional(),
    corte_energia_posible: z.boolean().optional()
  }),
  carpinteria: z.object({
    material: z.enum(['MDF','Madera maciza','Melamina','Aluminio','PVC','Otro']),
    tipo_elemento: z.array(z.enum(['Muebles a medida','Puertas/Marcos','Placares','Aberturas','Reparaciones','Deck'])).min(1),
    medidas_aprox: z.string().optional(),
    terminacion: z.enum(['Laca','Barniz','Pintura','Enchapado','Melamina','Sin terminación']).optional()
  }),
  jardinero: z.object({
    tipo_servicio: z.array(z.enum(['Corte de césped','Poda','Diseño de jardín','Riego','Limpieza','Control de plagas'])).min(1),
    area_m2: numPos.optional(),
    retiro_de_residuos: z.boolean().optional(),
    frecuencia: z.enum(['Único','Semanal','Quincenal','Mensual']).optional()
  }),
  servicio_domestico: z.object({
    tipo_espacio: z.enum(['Hogar','Oficina','Obra post-construcción','Mudanza','Profunda']),
    superficie_m2: numPos.optional(),
    cantidad_ambientes: numPos.optional(),
    provee_insumos: z.enum(['Cliente','Prestador','A definir']),
    frecuencia: z.enum(['Único','Semanal','Quincenal','Mensual']).optional()
  })
};

export const buildSchema = (serviceKey) => {
  const s = serviceSchemas[serviceKey];
  if (!s) return commonSchema;
  return commonSchema.and(s);
};

export const getFormSpecs = (serviceKey) => {
  const specifics = serviceForms[serviceKey] || [];
  return [...commonFields, ...specifics];
};